"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabsStyles = void 0;
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../../style/commons/_colors");
exports.useTabsStyles = (0, core_1.makeStyles)(function () { return ({
    wrapper: {
        fontFamily: 'Roboto',
        fontSize: 16,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        textTransform: 'capitalize',
        display: 'flex',
        flexDirection: 'row',
        color: _colors_1.darkSecondary,
        '& > *:first-child': {
            marginRight: 8,
            marginBottom: '0 !important',
        },
    },
    textColorInherit: {
        color: _colors_1.textInputColor,
    },
    selected: {
        color: _colors_1.darkSecondary,
        boxShadow: "0 2px 0 0 ".concat(_colors_1.darkSecondary, " !important"),
    },
    disabled: { opacity: '0.4 !important' },
    root: {
        minWidth: 60,
        padding: '0 16px',
        minHeight: 48,
        boxShadow: "0 2px 0 0 ".concat(_colors_1.secondaryColor),
        '&:hover': {
            background: _colors_1.secondaryHover,
            boxShadow: "0 2px 0 0 ".concat(_colors_1.brandPrimaryExtraDark, " !important"),
        },
    },
    indicator: {
        height: 0,
    },
    flexContainer: {
        width: '100%',
        borderBottom: "2px solid ".concat(_colors_1.lightBlue),
    },
    '&:hover': {
        background: 'red',
    },
}); });
